import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	EditProperty,
	PropertyDetailsEvent,
	PropertyType,
} from '../add-property-details/add-property-details.component';
import { MatDivider } from '@angular/material/list';
import { MatButton } from '@angular/material/button';
import { HasSystemCapabilityDirective } from '../../../directives/system-capabilities/has-system-capability.directive';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-add-property-confirmation',
	templateUrl: './add-property-confirmation.component.html',
	styleUrls: [
		'./add-property-confirmation.component.scss',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [MatDivider, MatButton, HasSystemCapabilityDirective, FormsModule],
})
export class AddPropertyConfirmationComponent {
	@Input() editProperty!: EditProperty;
	@Input() propertyType!: PropertyType;

	@Output() propertyDetailsEvents = new EventEmitter<PropertyDetailsEvent>();

	constructor() {}

	incrementOnClick(): void {
		if (this.editProperty?.pendingInstalls != null) {
			if (this.editProperty.pendingInstalls >= 1000) {
				this.editProperty.pendingInstalls = 1000;
			} else {
				this.editProperty.pendingInstalls =
					this.editProperty.pendingInstalls + 1;
			}

			this.propertyDetailsEvents.emit({
				editProperty: this.editProperty,
				propertyType: this.propertyType,
			});
		}
	}

	decrementOnClick(): void {
		if (this.editProperty?.pendingInstalls != null) {
			if (this.editProperty.pendingInstalls <= 0) {
				this.editProperty.pendingInstalls = 0;
			} else {
				this.editProperty.pendingInstalls =
					this.editProperty.pendingInstalls - 1;
			}

			this.propertyDetailsEvents.emit({
				editProperty: this.editProperty,
				propertyType: this.propertyType,
			});
		}
	}
}
